import React from 'react';

import './support-tile.css';

const SupportTile = ({ copy, header, icon }) => {
    return (
        <div className="support-tile">
            {icon}
            {header && <h4>{header}</h4>}
            {copy && <p>{copy}</p>}
        </div>
    );
};

export default SupportTile;
